const projectData = [
    {
        name: "Foodeli", 
        link: "https://github.com/drakenevadie19/Foodeli.git",
        src: "/project-bio-image/mobile-app-for-restaurant.jpg",
        description: "A responsive and intuitive restaurant web application allowing users to view restaurants details and order foods.",
        workTime: "7/2024 - Present",
        techStack: ["Angular", "TypeScipts", "MongoDB", "Boostrap 5", "Spring Boot", "Netflix Eureka", "MicroServices", "MySQL", "Docker", "Kubernetes", "JUnit", "Sonar", "Jenkins", "ArgoCD", "AWS", "RESTful API", "Github", "Postman", "MongoDB Atlas", "MongoDB Compass"],
        // techstacks: ["js", "react", "html", "css", "bootstrap", "nodejs", "express", "firebase", "postman", "mongodb", "vscode", "git", "github", "gcp"],
        liveDemo: ["yes", "https://foodeli-eh8uw3if3-thanh-nguyen-dos-projects.vercel.app/home"],
        participants: "Drake Do",
    },
    {
        name: "CineMatch",
        link: "https://github.com/drakenevadie19/CineMatch.git",
        src: "/project-bio-image/movie-review.png",
        description: "CineMatch is a smart movie discovery app that recommends films based on your watch history and preferences. It offers a personalized experience, making it easy to explore and find movies tailored to your taste. Whether you're looking for a blockbuster hit or a hidden gem, CineMatch ensures you always have the perfect movie to watch.",
        workTime: "02/2024 - 03/2024",
        techStack: ["React.js", "Redux", "Node.js", "Express.js", "GraphQL", "Apollo client", "MongoDB", "Mongoose", "MongoDB Atlas"],
        liveDemo: ['yes', "cinematch-nine-silk.vercel.app"],
        participants: "Drake Do",
    },
    {
        name: "MotivateMe", 
        link: null,
        src: "/project-bio-image/Bookez.png",
        description: "Motivate Me is a health tracking app that helps users build consistent wellness habits through personalized motivation and smart tracking. It supports physical, mental, and emotional health goals by offering intuitive progress tracking, AI-generated quotes, and intelligent unit suggestions—all designed to make self-care simple and sustainable.",
        workTime: "09/2024 - 05/2025",
        techStack: ["Java", "JavaScript", "React Native", "Node.js", "Expo", "Spring Boot", "Hibernate ORM", "Railway", "MongoDB", "PostgreSQL", "H2 Database", "Material UI", "Postman", "SweetAlert", "Docker", "GitHub Actions", "Render (web hosting)"],
        // techstacks: ["js", "react", "html", "css", "bootstrap", "nodejs", "express", "firebase", "postman", "mongodb", "vscode", "git", "github", "gcp"],
        liveDemo: ["yes", "https://motivateme2025.my.canva.site/"],
        participants: "Drake Do, Mary Beth Wash, Kien Pham, Carolina Heredia, JC Guardian, Jailyn Ruffin",
        posterLink: "/project-bio-image/SRS Poster Motivate Me.pdf",
        demoLink: "https://www.youtube.com/embed/lgMbaNo4RUY"
    },
    {
        name: "BOOKEZ", 
        link: "https://github.com/Web103-BookEZ/web103_finalproject.git",
        src: "/project-bio-image/Bookez.png",
        description: "My final capstone project for WEB 103 of Codepath. This is a website for users to book appointment with favourite hairdresser and manicurists in their favourite salon.",
        workTime: "11/2024 - Present",
        techStack: ["React.js", "JavaScript", "PostgreSQL", "Express.js", "Node.js", "Railway", "Material UI", "Postman", "SweetAlert"],
        // techstacks: ["js", "react", "html", "css", "bootstrap", "nodejs", "express", "firebase", "postman", "mongodb", "vscode", "git", "github", "gcp"],
        liveDemo: ["yes", "https://bookez.vercel.app/"],
        participants: "Drake Do",
    },
    {
        name: "SuperFrog Scheduler",
        link: "https://github.com/drakenevadie19/SuperFrogSchedulerFrontEnd",
        src: "/project-bio-image/superFrog.jpg",
        description: "Our goal is to provide the TCU campus with superior technology and a robust infrastructure that will meet the needs of a growing student and employee population. We are dedicated to securing, supporting, and assisting users with the technology services that we provide.",
        workTime: "4/2023 - 5/2023",
        techStack: ["JavaScript", "Java", "Node.js", "Vue.js", "Spring Boot", "MySQL", "Microsoft Azure"],
        liveDemo: ['no'],
        participants: "Drake Do, Kien Pham, Joey Herzog, Taylor Griffin, Eric Guyette, Tommy Truong",
    },
    {
        name: "MindBloom", 
        link: "https://github.com/drakenevadie19/MindBloom.git",
        src: "/project-bio-image/BlogApp.jpg",
        description: "Architectured a fullstack website blog application with MERN-stack allowing users to save memories and articles.",
        workTime: "12/2023 - 4/2024",
        techStack: ["JavaScript", "MongoDB", "Express.js", "React.js", "React Hooks", "Node.js", "RESTful API", "Postman", "MongoDB Atlas", "Axios", "Firebase", "Heroku"],
        // techstacks: ["js", "react", "html", "css", "bootstrap", "nodejs", "express", "firebase", "postman", "mongodb", "vscode", "git", "github", "gcp"],
        liveDemo: ["yes", "https://drakedo-blog-app-7c34e913c768.herokuapp.com/"],
        participants: "Drake Do",
    },
    {
        name: "Two Tree Ecommerce App",
        link: "https://github.com/drakenevadie19/TwoTreeEcommerceApp.git",
        src: "/project-bio-image/ecommerceApp.png",
        description: "Designed an fullstack interface with MEVN-stack for shopping demands of users with fully necessary functions for a shopping page. I am still working on this page to develop more.",
        workTime: "1/2024 - 4/2024",
        techStack: ["JavaScript", "Vue.js", "Node.js", "Express.js", "RESTful API", "Postman", "MongoDB", "Mongo Atlas", "Axios", "Render (web hosting)"],
        // techstacks: ["js", "vue", "html", "css", "bootstrap", "nodejs", "express", "postman", "mongodb", "vscode", "git", "github", "gcp"],
        liveDemo: ['yes', "https://two-tree-ecommerce-app.onrender.com/"],
        participants: "Drake Do",
    },
    {
        name: "sudokuGame",
        link: "https://github.com/drakenevadie19/sudokuGame",
        src: "/project-bio-image/sudokuGame.jpg",
        description: "Inspired by traditional sudoku game, I design a web page for users to solve their maze, and also play Sudoku there. I created a responsive design website, using Angular framework, with Material UI.",
        workTime: "07/2023 - 08/2023",
        techStack: ["TypeScripts", "Angular.js", "Ngrx", "RxJS", "Bootstrap", "Material UI", "SweetAlert"],
        liveDemo: ['yes', "https://sudoku-game-psi.vercel.app/home"],
        participants: "Drake Do",
    },
    {
        name: "DevLookUp",
        link: "https://github.com/drakenevadie19/ghProfileFinder.git",
        src: "/project-bio-image/devlookup.png",
        description: "An interface to find Github profile by name and github account using Github APIs",
        workTime: "05/2024 - 06/2024",
        techStack: ["React.js", "JavaScript", "Axios", "Bootstrap"],
        liveDemo: ['yes', "https://dev-lookup-iq5l.vercel.app/"],
        participants: "Drake Do",
        demoLink: "https://www.youtube.com/embed/K9QcS3IDIaU"
    },
    {
        name: "Daily Diary app", 
        link: "https://github.com/drakenevadie19/dailyDiaryApp.git",
        src: "/project-bio-image/diaryapp.jpeg",
        description: "Developed a fullstack website diary application with MERN-stack allowing users to save daily diary for healing after a long day.",
        workTime: "05/2023 - Present",
        techStack: ["Next.js", "JavaScript", "MongoDB", "Node.js", "RESTful API", "Postman", "MongoDB Atlas"],
        // techstacks: ["js", "react", "html", "css", "bootstrap", "nodejs", "express", "firebase", "postman", "mongodb", "vscode", "git", "github", "gcp"],
        liveDemo: ['no'],
        participants: "Drake Do",
    },
    {
        name: "Hogwart Artifact Online",
        link: "https://github.com/drakenevadie19/hogwart-artifact-online",
        src: "/project-bio-image/hogwart.jpg",
        description: "Developed a fully-fledged RESTful API server to manage wizard object entity and artifact object entity using SpringBoot, Spring MVC, Spring Data JPA and H2 database.",
        workTime: "03/2023 - 04/2023",
        techStack: ["Java", "Spring Boot", "Spring Data", "Spring JPA", "JWT", "H2 Database", "Spring Security"],
        // techstacks: ["java", "react", "html", "css", "bootstrap", "nodejs", "materialui", "postman", "spring", "vscode", "git", "github", "idea"],
        liveDemo: ['no'],
        participants: "Drake Do",
    },
    // {
    //     name: "Contact Interface",
    //     link: "https://github.com/drakenevadie19/ContactInterface.git",
    //     src: "/project-bio-image/contactInterface.png",
    //     description: "Designed an fullstack interface using React and Spring Boot to store and manage contacts",
    //     workTime: "11/2023 - 12/2023",
    //     techStack: ["Java", "React.js", "Materialize CSS", "Bootstrap", "Spring Boot", "RESTful API", "Postman"],
    //     // techstacks: ["js", "java", "react", "html", "css", "bootstrap", "nodejs", "materialui", "postman", "spring", "vscode", "git", "github", "idea"],
    //     liveDemo: ['no'],
    //     participants: "Drake Do",
    // },
    {
        name: "Book Manager Database 1&2",
        link: "https://github.com/drakenevadie19/BookManager",
        src: "/project-bio-image/books.jpg",
        description: "Guided Dr. Sarka in TCU, I developed a database system for managing new books coming for TCU, using Python and MySQL. This database can also handle queries such as searching a book/books, changing books' information, deleting books. For IDE, I used Pycharm for Python and Datagrip, with Docker to monitor database.",
        workTime: "10/2023 - 11/2023",
        techStack: ["MySQL", "Python", "MongoDB", "Docker"],
        liveDemo: ['no'],
        participants: "Drake Do",
    },
]

export default projectData;

